// Cleans the HTML of a popover (data-content may hold text that came from
// ORIS or from a member): only a small set of harmless tags and attributes
// survives, as in Bootstrap 3.4's own sanitizer.

const ALLOWED_TAGS = new Set([
  "A", "B", "BR", "CODE", "DIV", "EM", "HR", "I", "IMG", "LI", "OL", "P", "PRE", "S",
  "SMALL", "SPAN", "SUB", "SUP", "STRONG", "U", "UL",
  "H1", "H2", "H3", "H4", "H5", "H6",
]);

const ALLOWED_ATTRIBUTES = {
  "*": ["class", "dir", "id", "lang", "role", "data-dismiss"],
  A: ["target", "href", "title", "rel"],
  IMG: ["src", "alt", "title", "width", "height"],
};

// Relative URLs and the usual safe schemes; never javascript:.
const SAFE_URL = /^(?:(?:https?|mailto|ftp|tel|file):|[^#&/:?]*(?:[#/?]|$))/i;

function attributeAllowed(element, attribute) {
  const name = attribute.name.toLowerCase();
  if (name.startsWith("aria-")) return true;
  const allowed = [...ALLOWED_ATTRIBUTES["*"], ...(ALLOWED_ATTRIBUTES[element.tagName] || [])];
  if (!allowed.includes(name)) return false;
  if (name === "href" || name === "src") return SAFE_URL.test(attribute.value.trim());
  return true;
}

export function sanitizeHtml(html) {
  const doc = new DOMParser().parseFromString(`<body>${html}</body>`, "text/html");
  const walk = (parent) => {
    Array.from(parent.childNodes).forEach((node) => {
      if (node.nodeType === Node.TEXT_NODE) return;
      if (node.nodeType !== Node.ELEMENT_NODE || !ALLOWED_TAGS.has(node.tagName)) {
        node.remove();
        return;
      }
      Array.from(node.attributes).forEach((attribute) => {
        if (!attributeAllowed(node, attribute)) node.removeAttribute(attribute.name);
      });
      walk(node);
    });
  };
  walk(doc.body);
  return doc.body.innerHTML;
}
